import { create } from "zustand";

interface SpecAnalysisState {
  budgetPrice: number;
  sumPrice: number;
  matchRate: string;

  setBudgetPrice: (value: number) => void;
  setSumPrice: (value: number) => void;
  setMatchRate: (value: string) => void;
  resetSummary: () => void;
}

export const useSpecAnalysisStore = create<SpecAnalysisState>((set) => ({
  budgetPrice: 0,
  sumPrice: 0,
  matchRate: "-",

  setBudgetPrice: (value) => set({ budgetPrice: value }),
  setSumPrice: (value) => set({ sumPrice: value }),
  setMatchRate: (value) => set({ matchRate: value }),

  resetSummary: () =>
    set({
      budgetPrice: 0,
      sumPrice: 0,
      matchRate: "",
    }),
}));
